<div
  *ngIf="context.flag && context.activeTab === 'in-cart' && context.showInCart"
  style="overflow: hidden"
>
  <p *ngIf="!context.tableData.length" class="m-0">No data found</p>
  <table
    datatable
    [dtOptions]="context.cartTableDtOptions"
    class="row-border hover m-0 w-100"
  >
    <thead>
      <tr>
        <th *ngFor="let thead of context.cartTheads">{{ thead }}</th>
      </tr>
    </thead>
    <tbody></tbody>
  </table>
</div>
